import React from 'react';
import OrderButton from '../../components/common/OrderButton/OrderButton';
import DeliveryIcon from './DeliveryIcon';
import './Delivery.less';

class Delivery extends React.Component {
  render () {
    return (
      <section className="section section-delivery">
        <div className="grid-sm-2 container-limit">
          <div className="delivery-icon-placeholder"/>
          <DeliveryIcon />
          <article className="delivery-info container">
            <OrderButton />
            <p>
              Pn - Pt: 10:00 - 23:00<br/>
              Sob - Nd: 12:00 - 20:00
            </p>
            <article className="story">
              <p>
                Dostawa w określonej strefie w ciągu 60 min.
              </p>
            </article>
          </article>
        </div>
      </section>
    );
  }
}

export default Delivery;



// WEBPACK FOOTER //
// ./src/components/Delivery/Delivery.js